module.exports = __webpack_public_path__ + "static/Recicla-d22110f8d46dea4521b362d8f5324054.png";